import { useEffect, useState } from "react";
import { Button } from "../../../../core/components/Button";
import { Input } from "../../../../core/components/Input";
import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { WarningIcon } from "../../../../core/icons/Warning";
import { ArrowRightIcon } from "../../../../core/icons/ArrowRight";

export const GeneralDetail: React.FC<{
	title: string;
	setTitle: (value: string) => void;
	description: string;
	setDescription: (value: string) => void;
	next: () => void;
	back: () => void;
}> = ({ back, title, setTitle, description, setDescription, next }) => {
	const [inputError, setInputError] = useState(false);

	useEffect(() => {
		if (title !== "") setInputError(false);
	}, [title]);

	const handleNext = () => {
		if (title === "") {
			setInputError(true);
			return;
		}
		next();
	};

	return (
		<>
			<Column className="gap-1 lg:gap-2">
				<Input
					id="title"
					label="Título del Evento"
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					error={inputError}
				/>
				{inputError && (
					<Row
						className="text-red-500 gap-0.5"
						crossAxisAlignment="center"
					>
						<WarningIcon className="w-3.5 h-3.5 lg:w-5 lg:h-5" />
						<TextComponent variant="h6">Este campo es obligatorio</TextComponent>
					</Row>
				)}
			</Column>
			<Input
				id="description"
				label="Descripción"
				value={description}
				onChange={(e) => setDescription(e.target.value)}
			/>
			<Column className="w-full gap-2">
				<Row
					className="gap-2 font-bold"
					flexible
					responsiveCol
				>
					<Button
						className="md:w-1/2"
						color="yellow"
						onClick={back}
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<ArrowRightIcon className="w-5 h-5 rotate-180" />
							<span>Atrás</span>
						</Row>
					</Button>
					<Button
						className="md:w-1/2 max-md:order-first"
						onClick={handleNext}
						color="orange"
						secondary
					>
						<Row
							className="gap-1"
							crossAxisAlignment="center"
							mainAxisAlignment="center"
						>
							<span>Siguiente</span>
							<ArrowRightIcon className="w-5 h-5" />
						</Row>
					</Button>
				</Row>
			</Column>
		</>
	);
};
